var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NotificationInPage',{attrs:{"actionText":"Deactivate","notification":_vm.$options.deactivateNotification,"showNotification":true},on:{"action":_vm.handleShowDeactivateModal}}),_c('PasswordManagerConfirmDeactivateModal',{attrs:{"showModal":_vm.showDeactivateModal},on:{"close":_vm.handleCloseDeactivateModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }